/**
 * Client entry — used for both dev and after SSG.
 */
import { createBloxApp } from '@bagelink/blox'
import { BagelVue, RouterWrapper } from '@bagelink/vue'
import { createApi, axios } from '@shared/api'

import '@bagelink/vue/styles/core.css'
import '@bagelink/blox/style.css'
import '@/styles/theme.css'
import '@/styles/main.css'

import App from './App.vue'
import router from './router'

const blocks = import.meta.glob('./components/blocks/*.vue', { eager: true })

createBloxApp({
	rootComponent: App,
	router,
	modules: blocks as Record<string, any>,
	websiteName: 'ati',
	store: 'ati',
	createApi: ({ baseURL }) => { createApi({ baseURL }); return { axios } },
	plugins: [[BagelVue, {}]],
	globalComponents: { RouterWrapper },
})
